import request from './request/default';
import * as qs from 'qs';

export function getOrderList(certType, certNo) {
  const params = { certType, certNo };
  return request
    .get(`/aas/api/v1/motor/orders`, { params })
    .then(res => res.data);
}

export function getOrderDetail(orderNo, proposalNo) {
  const params = { proposalNo };
  return request
    .get(`/aas/api/v1/motor/orders/${orderNo}`, { params })
    .then(res => res.data);
}

export function orderPayment(orderNo, paymentType, code, proposalNo, appid) {
  const data = { code, paymentType, proposalNo, appid };
  return request
    .post(`/aas/api/v1/motor/orders/${orderNo}`, data)
    .then(res => res.data);
}

export function getPolicy(policyNo, certType, certNo) {
  const params = { certType, certNo };
  return request
    .get(`/aas/api/v1/motor/policies/${policyNo}`, { params })
    .then(res => res.data);
}

export function getReportsWithPolciyNo(policyNo, certType, certNo) {
  const params = { policyNo, certType, certNo };
  return request
    .get('/aas/api/v1/motor/reports', { params })
    .then(res => res.data);
}

export function getReport(reportNo, certType, certNo) {
  const params = { certType, certNo };
  return request
    .get(`/aas/api/v1/motor/reportsByCert/${reportNo}`, { params })
    .then(res => res.data);
}

export function orderCertificate(applyno, openid, isWxApplet) {
  const data = { applyno, openid, isWxApplet };
  return request
    .post(`/aas/api/v1/motor/orders/orderCertificate`, data)
    .then(res => res.data);
}

export function wechatOrderPayment(orderNo, paymentType, code, proposalNo) {
  const data = { code, paymentType, proposalNo };
  return request
    .post(`/aas/api/v1/motor/orders/wechat/${orderNo}`, data)
    .then(res => res.data);
}

export function getOpenId(paymentType, code, appid) {
  const data = { paymentType, code, appid };
  return request
    .post(`/aas/api/v1/motor/getOpenId`, data)
    .then(res => res.data);
}

export function getAgreement(url) {
  return request
    .get(`/aas/api/v1/reptile?${qs.stringify({ url })}`)
    .then(res => res.data);
}
